import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ThemeReinit() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Defer until *after* the next paint to avoid racing React commits
    const afterPaint = () =>
      new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

    let cancelled = false;
    (async () => {
      await afterPaint();
      if (cancelled) return;

      try {
        console.log('[ThemeReinit] re-init for path:', pathname);

        // ------- DLAB SETTINGS (idempotent) -------
        const opts = window.dlabSettingsOptions || {};
        if (typeof window.reapplyDlabSettings === 'function') {
          window.reapplyDlabSettings();
        } else if (typeof window.dlabSettings === 'function') {
          // destroy old instance if theme exposes destroy()
          if (window.__dlabInst__?.destroy) {
            try {
              window.__dlabInst__.destroy();
            } catch {}
          }
          window.__dlabInst__ = new window.dlabSettings(opts);
        }

        // ------- jQuery plugins (idempotent) -------
        // ------- jQuery nice-select (clean + rebuild, idempotent) -------
        const $ = window.$;
        if ($?.fn?.niceSelect) {
          $('select').each(function () {
            const $sel = $(this);

            // If plugin already attached, destroy it FIRST
            try {
              $sel.niceSelect('destroy');
            } catch {}

            // Remove any stray wrappers that might remain
            const $next = $sel.next('.nice-select');
            if ($next.length) $next.remove();

            // Rebuild
            $sel.show().niceSelect();
          });
        }

        // tooltips
        if ($?.fn?.tooltip) $('[data-bs-toggle="tooltip"]').tooltip();

        // metis / left nav: dispose then re-init if available
        // ------- metis / left nav: dispose then re-init ONLY for non-React menus -------
        if ($?.fn?.metisMenu) {
          $('.metismenu').each(function () {
            const el = this;
            // If React owns this menu, DO NOT touch it
            if (el.dataset.reactManaged === 'true') return;

            try {
              $(el).metisMenu('dispose');
            } catch {}
            $(el).metisMenu();
          });
        }

        // Clean any stray backdrops that might block first click
        document
          .querySelectorAll(
            '.modal-backdrop, .offcanvas-backdrop, .mm-backdrop'
          )
          .forEach((el) => {
            try {
              el.remove();
            } catch {}
          });

        // Safety: ensure nothing ended hidden by theme toggle race
        ['#root', '#root > div', '.content-body', '.dlabnav', 'body'].forEach(
          (sel) => {
            const el = document.querySelector(sel);
            if (!el) return;
            el.style.removeProperty('display');
            el.style.removeProperty('visibility');
            el.style.removeProperty('opacity');
            el.classList?.remove('hidden', 'd-none', 'opacity-0', 'invisible');
          }
        );

        // Force layout recalcs some theme scripts listen for
        window.dispatchEvent(new Event('resize'));

        console.log('[ThemeReinit] done');
      } catch (err) {
        console.error('[ThemeReinit] failed:', err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [pathname]);

  return null;
}
